import React from 'react';
import BaseModal from 'src/common/components/Modal';
import SVG from 'react-inlinesvg';
import { ICONS } from 'src/utils/icon-urls.utils';

const FirstLogin = ({ open, setOpen, onConfirm }) => {
	return (
		<BaseModal
			open={open}
			onConfirm={() => onConfirm()}
			onClose={() => setOpen(false)}
		>
			<h2 className="text-center">
				<SVG src={ICONS.LOCK} width="90px" height="90px" className="mb-5" />
				<div className="text-danger">
					Como es tu primer acceso debes actualizar tu contraseña
				</div>
			</h2>
		</BaseModal>
	);
};

export default FirstLogin;
